import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../services/api.service';
import { UtilitiesService } from '../services/utilities.service';
import Swal from 'sweetalert2'

@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.css'],
    standalone: false
})
export class ProfileComponent implements OnInit {

  id: any;
  token: any;
  user: any;
  employee: any;

  Swal = 'sweetalert2'

  user_password = {
    id: null,
    email: '',
    password: '',
  }

  slots: any[] = [];

  slot = {
    date: '',
    doctor_id: null,
    reason: '',
    period: 30
  }

  constructor(public utility: UtilitiesService, private router: Router, public api: ApiService, private modalService: NgbModal) {
    this.utility.show = true;
    this.token = localStorage.getItem('access_token');
    this.id = localStorage.getItem('id');
  }

  ngOnInit(): void {
    this.getUser();
  }

  changeP(content: any, user: any) {
    this.user_password.id = user.id;
    this.user_password.email = user.email;
    this.user_password.password = user.password;

    this.modalService.open(content);
  }

  open(content: any) {
    this.modalService.open(content);
  }

  getUser() {
    this.utility.loading = true;
    let id = localStorage.getItem('id');
    if (id) {
      const sub = this.api.get('users/' + id, this.token).subscribe(
        async data => {
          let objects: any = {
            users: []
          }
          objects = data;

          this.user = objects.users[0][0];
        },
        async error => { }
      );

      sub.add(() => { this.getDetails(id); });
    }
  }

  getDetails(id: any) {
    const sub = this.api.get('employees/user/' + id, this.token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;

        this.employee = objects;
      },
      async error => { }
    );
    sub.add(() => { this.utility.loading = false; });
  }

  getMySlots(id: any) {
    const sub = this.api.get('schedules/' + id, this.token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;

        this.slots = objects.schedules;
      },
      async error => { }
    );
    sub.add(() => { this.utility.loading = false; });
  }

  OnChangePassword(id: any) {
    const body = {
      password: this.user_password.password
    }

    this.api.update("users/password/" + id, body, this.token).subscribe(
      async data => {
        Swal.fire({
          title: 'Success!',
          text: 'Password Changed Successfuly!',
          icon: 'success',
          confirmButtonText: 'Cool'
        })
      },
      async error => {
        Swal.fire({
          title: 'Error!',
          text: 'Something went wrong!',
          icon: 'error',
          confirmButtonText: 'Ok'
        })
      }
    );

    this.modalService.dismissAll();
  }

  createSlot() {
    if (this.employee) {
      const body = {
        date_time: this.slot.date,
        period: this.slot.period,
        active: true,
        blocked: true,
        doctor_id: this.employee.id,
        reason: this.slot.reason,
      }

      const sub = this.api.post("schedules/", body, this.token).subscribe(
        async data => {
          let objects: any = {}
          objects = data;

          Swal.fire({
            title: 'Success!',
            text: 'Slot Booked Successfuly!',
            icon: 'success',
            confirmButtonText: 'Cool'
          });
        },
        async error => {
          Swal.fire({
            title: 'Error!',
            text: 'Something went wrong!',
            icon: 'error',
            confirmButtonText: 'Ok'
          });
        }
      );
    }
    else {
      Swal.fire({
        title: 'info!',
        text: 'You are not a Clinician!',
        icon: 'warning',
        confirmButtonText: 'Ok'
      });
    }
  }

  async applyLeave() {
    let id; // get employee id
    const body = {
      status: 'LEAVE'
    }

    this.api.update(`employees/${id}/status`, body, this.token).subscribe(
      async data => {
        this.getUser();
        Swal.fire({
          title: 'Success!',
          text: 'Updated Successfuly!',
          icon: 'success',
          confirmButtonText: 'Cool'
        })
      },
      async error => {
        Swal.fire({
          title: 'Error!',
          text: 'Something went wrong!',
          icon: 'error',
          confirmButtonText: 'Ok'
        });
      }
    );

    this.modalService.dismissAll();
  }

  saveDoctor(doctor: any) {
    localStorage.setItem('doctor', JSON.stringify(doctor));
  }
}
